import {Component, inject, input, OnInit} from '@angular/core';
import {QtyInputComponent} from '@layout/components/product/qty-input/qty-input.component';
import {Maybe, WineProduct} from '@core/interfaces/generated/graphql';
import {ProductService} from '@core/services/product.service';
import {BehaviorSubject, Observable} from 'rxjs';
import {AsyncPipe, CurrencyPipe} from '@angular/common';
import {formatPrice} from '@core/pipes/price.pipe';
import {map} from 'rxjs/operators';
import {CartService} from '@core/services/cart.service';
import {LoadingComponent} from '@layout/components/general/loading/loading.component';
import {GoogleService} from '@core/services/google.service';
import {StoreConfigService} from '@core/services/store-config.service';

@Component({
  selector: 'app-product-sticky-buy-bar',
  templateUrl: './product-sticky-buy-bar.component.html',
  styleUrls: ['./product-sticky-buy-bar.component.scss'],
  imports: [
    QtyInputComponent,
    AsyncPipe,
    CurrencyPipe,
    LoadingComponent
  ]
})
export class ProductStickyBuyBarComponent implements OnInit {
  private productService = inject(ProductService);
  private cartService = inject(CartService);
  private googleService = inject(GoogleService);
  private storeConfigService = inject(StoreConfigService);


  qtyInput: number;
  productPrice$: Observable<{ price: number, qty: Maybe<number | undefined> }>
  disableAddToCartBtn = new BehaviorSubject(false);
  success = new BehaviorSubject(false);

  readonly product = input<WineProduct>();

  currencyCode = this.storeConfigService.currencyCode;

  ngOnInit(): void {
    const product = this.product();
    if (!product) {
      return;
    }
    this.qtyInput = product?.defaultQuantity ?? 1;
    this.productPrice$ = this.productService.getDefaultPriceAsync(product).pipe(
      map(price => {
        return {
          price: formatPrice(price.discount?.amountIncVat || price.amountIncVat),
          qty: price.minQty
        };
      })
    );
  }

  async addToCart() {
    this.disableAddToCartBtn.next(true);

    const product = this.product();
    if (!product) {
      return;
    }
    const isPreorder = !!product?.preorderDate;
    const isEnPrimeur = !!product?.isEnPrimeur;
    await this.cartService.addToCart(product.vismaProductNumber, product.id as any, this.qtyInput, 'product-page', undefined, undefined, isPreorder, isEnPrimeur);
    this.googleService.addProductToCartEvent(product, this.qtyInput);
    this.qtyInput = product?.defaultQuantity ?? 1;
    this.disableAddToCartBtn.next(false);
    this.showSuccess();
  }

  showSuccess() {
    this.success.next(true);
    setTimeout(() => {
      this.success.next(false);
    }, 2000);
  }

}
